import { useQueryClient } from '@tanstack/react-query'
import { fetchCurrencyExchangeRate } from 'shared/currency-exchange-rate/api/fetchCurrencyExchangeRate'
import { QueryKeys } from '../../../key-registry'
import { fetchTransitOperation } from '../api/fetchTransitOperation'
import { sendSubmission } from '../api/http'

function useSubmitTransitOperation(transitOperationId: number | null) {
  const qc = useQueryClient()

  const submitTransitOperation = async (country: string | null) => {
    if (!transitOperationId) throw new Error('Missing transit operation id')
    const currencyExchangeRate = await fetchCurrencyExchangeRate(country)
    await sendSubmission({
      id: transitOperationId,
      currencyExchangeRate,
    })

    const updated = await fetchTransitOperation(transitOperationId)
    qc.setQueriesData(
      {
        queryKey: QueryKeys.transitOperation.detailById({ id: updated.id as number }),
      },
      (prev) => {
        if (!prev) return prev
        return { ...prev, ...updated }
      },
    )
    await qc.invalidateQueries({
      queryKey: QueryKeys.eventLog.all(transitOperationId),
    })

    return updated
  }

  return {
    submitTransitOperation,
  }
}

export default useSubmitTransitOperation
